<article>
	<section>
		<cache-date></cache-date>
	</section>
	
	<header>
		<h3>
			{{ 'adminstat.common._Mails' | translate }}
		</h3>
	</header>
	
	<section>
		<div class="form-group">
			<ng-container *ngFor="let dateType of filter.filterParams.dateFilterParams | keys">
				{{ 'adminstat.filterForm.' + dateType | translate }}
				
				<select
					class="form-control"
					[(ngModel)]="filter.filterParams.dateFilterParams[dateType].type"
					[ngModelOptions]="{standalone: true}"
					[sextant]="'filter-dateType.' + dateType"
				>
					<option
						*ngFor="let opt of ['all', 'now', 'yesterday', 'prevWeek', 'prevMonth', 'last7day', 'last30day', 'other']"
						value="{{ opt }}"
						[selected]="opt == filter.filterParams.dateFilterParams[dateType].type"
					>
						{{ 'adminstat.common.interval.' + opt | translate }}
					</option>
				</select>
				
				<table>
					<tr [style.display]="filter.filterParams.dateFilterParams[dateType].type != 'other' ? 'none' : null">
						<td>
							<datepicker
								[(ngModel)]="filter.filterParams.dateFilterParams[dateType].start"
								[ngModelOptions]="{standalone: true}"
								[format]="'DD-MM-YYYY'"
							></datepicker>
							
							<datepicker
								[(ngModel)]="filter.filterParams.dateFilterParams[dateType].end"
								[ngModelOptions]="{standalone: true}"
								[format]="'DD-MM-YYYY'"
							></datepicker>
						</td>
					</tr>
				</table>
			</ng-container>
			
			{{ 'adminstat.common.language' | translate }}
			
			<select
				class="form-control"
				[(ngModel)]="filter.filterParams.lang"
				[ngModelOptions]="{standalone: true}"
				[sextant]="'filter-lng'"
			>
				<option
					*ngFor="let opt of localesMap | keys"
					value="{{ opt }}"
					[selected]="opt == filter.filterParams.lang"
				>
					{{ localesMap[opt] }}
				</option>
			</select>
			
			{{ 'adminstat.users.reg_day.Mail domain' | translate }}
			
			<select 
				class="form-control"
				[(ngModel)]="filter.filterParams.email"
				[ngModelOptions]="{standalone: true}"
				[attr.radio]="'list'"
			>
				<option
					*ngFor="let opt of [defaultEmailFilter].concat(emailList)"
					value="{{ opt }}"
					[selected]="opt === filter.filterParams.email"
				>

					<ng-container
					*ngIf="opt === defaultEmailFilter; else emailFilter"
					>
						{{ 'adminstat.mails.mail_ga.all except yandex' | translate }}
					</ng-container>

					<ng-template #emailFilter>
						{{ opt }}
					</ng-template>

				</option>
			</select>
			
			
			{{ 'adminstat.filterForm.subject' | translate }}
			<ng-selectize
				[sextant]="'filter-subjectType'"
				[config]="subjectTypeConfig.config"
				[options] = "subjectTypeConfig.options"
				[(ngModel)]="filter.filterParams.subjectType"
				[ngModelOptions]="{standalone: true}"
			>
			</ng-selectize>
			
			<br>
			
			<button type="button" class="btn btn-success" [sextant]="'btnApplyFilters'" (click)="applyFilters()">{{ 'adminstat.common.Apply' | translate }}</button>
			<button type="button" class="btn btn-link" style="color:red;" (click)="resetFilters()">{{ 'adminstat.common.Reset filters' | translate }}</button>
		</div>
	</section>
	
	
	<section class="mb-5">
		{{ 'adminstat.mails.mail.sent count' | translate }}: {{ totalSent | prettyNumber }}
		<br/>
		{{ 'adminstat.mails.mail.not sent count' | translate }}: {{ totalNoSent | prettyNumber }}
	</section>
	
	<section class="mb-5">
		<div class="row ul-margin-bottom">
			<div class="col-md-12">
				<nav class="nav nav-pills flex-column flex-sm-row">
					<ng-container *ngFor="let _tab of tabs">
						<a
							[class]="tab === _tab ? 'period-tab flex-sm-fill text-sm-center nav-link active' : 'period-tab flex-sm-fill text-sm-center nav-link'"
							[routerLink]="['/mail']"
							[queryParams]="{tab: _tab}"
							[attr.tab]="_tab"
						>
							{{ 'adminstat.tabs.' + _tab | translate }}
						</a>
					</ng-container>
				</nav>
			</div>
		</div>
	</section>
	
	<section>
		<div
			class="row bottom-margin"
			*ngFor="let stat of stats"
		>
			<div class="col-md-6">
				<h3>
					{{ stat.name }}
				</h3>
			</div>
			
			<div class="col-md-6">
				<div
					class="btn-group btn-group-toggle float-right"
					ngbRadioGroup
					name="radioBasic"
					[(ngModel)]="stat.titlePrintType"
				>
					<label
						ngbButtonLabel
						class="btn-primary"
						(click)="changeTitleForChart(stat, _name)"
						*ngFor="let _name of ['name', 'service name']"
					>
						<input ngbButton type="radio" [value]="_name"> {{ i18nForSubject[_name] }}
					</label>
				</div>
			</div>
			
			<div class="col-md-12">
				<chart
					[name]="stat.name"
					[data]="stat.chart.data"
					[options]="stat.chart.options"
					(onFilterChange)="updateData($event, stat.name)"
					[sextant]="stat.name + '-chart'"
				></chart>
			</div>
			
			<div class="col-md-12" *ngIf="stat.name !== 'total' && stat.name !== 'others'">
				<table class="table">
					<tr *ngFor="let row of stat.table">
						<td class="js-mark" style="padding:5px;">
							{{ stat.titlePrintType === 'name' ? ('adminstat.mails.mail.' + row.name | translate) : row.name }}
						</td>
						
						<td style="padding: 5px;">
							<p>
								<label class="checkbox-inline">
									<input
										type="checkbox"
										[(ngModel)]="row.isShowSent"
									/>
									
									{{ 'adminstat.mails.mail_ga.sents' | translate }}
								</label>
							</p>
						</td>
						
						<td style="padding: 5px;">
							<p>
								<label class="checkbox-inline">
									<input
										type="checkbox"
										[(ngModel)]="row.isShowReaded"
									/>
									
									{{ 'adminstat.mails.mail_ga.reads' | translate }}
								</label>
							</p>
						</td>
					</tr>
				</table>
				
				<button
					type="button"
					class="btn btn-primary"
					(click)="showTable(stat)"
				>
					{{ 'adminstat.mails.mail_ga.table' | translate }}
				</button>
			</div>
			
			<div class="col-md-12">
				<hr/>
			</div>
		</div>
	</section>
	
	
	<section>
		<div class="row">
			<div class="col-md-12">
				<a target="_blank" href="/admin/stat/auth/google">
					{{ 'adminstat.mails.mail.Login Google Analytics' | translate }}
				</a>
			</div>
		</div>
	</section>
</article>
